import moment from 'moment-timezone';
import { resolveTimezone } from './timeDisplaySettings'

const momentUtcToUserTz = (val, deviceTimeZone) => {
	if (!val) {
		return "";
	}

	const localTZ = Intl.DateTimeFormat().resolvedOptions().timeZone;
	const userTimeZone = resolveTimezone(deviceTimeZone) || localTZ;

	return moment.utc(val).tz(userTimeZone);
};

export default momentUtcToUserTz
